import { defineComponent, h } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { ItemProps } from '@/ui/components/inspectionReport/types';

export const Form = defineComponent<ItemProps>({
  name: 'Form',
  props: ['item'],
  setup(props) {
    const { getSubItems } = useInspectionReport();

    return function render() {
      return h('div', [
        ...(props.item.items ? getSubItems(props.item.items) : []),
      ]);
    };
  },
});
